
import React from 'react';
import ReactDOM from "react-dom";
//import ReactDOMServer from "react-dom/server";
import { Provider } from 'react-redux';
import {store} from "../js/store/index";

import I18N from "../js/i18n";
import { PRODUCTS, EN, ZH_HK, I18N_LOCALES, UNITS } from '../constants/GlobalConstant';

export function formatUTC(utc) {
    const formattedDate = new Date(utc)
    .toLocaleDateString({},{timeZone:"UTC",month:"short", day:"2-digit", year:"numeric"})
    
    return formattedDate;    
}

export function formatCurrency(x) {
    let n = parseFloat(x).toFixed(2);
    return Number(n).toLocaleString('en',{ minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //return parseFloat(x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")).toFixed(2);    
}

export function getSearchTermMatch(item, searchTerms) {
    if(!item) {
        return true;
    }
    item = item.toLowerCase();
    let supplierMatch = true;
    if(searchTerms) {
        // remove all spaces
        let arr = searchTerms.split(' ').filter(entry => entry.trim() != '');
        
        if(arr.length) {
            if(searchTerms.length > 0) {
                let foo = arr.findIndex((substring) => {
                    if(item.includes(substring.toLowerCase()) === false){
                        supplierMatch = false;
                    }                    
                });
            }   
        }
    }
    return supplierMatch;
}

export function uint8ToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

export function dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'application/pdf'});
    return blob;
}

export function packagingUnitLabel(isShowPrice, goodsFormatNum,
    goodsFormatName,
    unitName,
    unitPrice) {

        //let label = `${goodsFormatName} ${isShowPrice && unitPrice > 0 ? ` HKD${unitPrice}` : ""}`;
        
        return ( <><I18N type={UNITS} value={goodsFormatName} def={goodsFormatName}/> 
            {isShowPrice && unitPrice > 0 ? ` HKD${unitPrice}` : ""}

            {goodsFormatName !== unitName
                ?
                <>
                    <>(1</>
                    <I18N type={UNITS} value={goodsFormatName} def={goodsFormatName}/>
                    <>= {goodsFormatNum}</>
                    <><I18N type={UNITS} value={unitName} def={unitName}/></>
                    <>)</>
                </>
                :
                ""
            }
        </>);

        //if (goodsFormatName !== unitName) {
        //    label = label + ` (1${goodsFormatName} = ${goodsFormatNum}${unitName})`;
        //}

        //return label;
}

export function toFixed(num, toFixed){
    if (num) {
      let split = num.toString().split(".");
      let len = 0;

      // ensure no 0 at the start, e.g. 011
      if(typeof num === 'string' && num.length > 1 && num.charAt(0) === '0' && !split[1]) {
        num = num.substring(1);
      }

      if (split[1]) {
        len = split[1].length;
      }
      if (len > toFixed) {
        return parseFloat(num).toFixed(toFixed);
      }
      return num;
    }
    return num;
}

export const i18n = (type, path, def) => {

    const span = document.createElement('span');
    ReactDOM.render(<Provider store={store}><I18N 
        type={type} 
        path={path} 
        def={def}/></Provider>, span, () => {
        });

    return new Promise((resolve, reject) => {
        setTimeout(() => {
            resolve(span.innerHTML);
        });
    });
}

export const getLocaleLabel = (locale) => {
    if(!locale) {
        locale = ZH_HK;
    }

    const getLocaleLabel = (locale) => {
        let filter = I18N_LOCALES.filter( (obj) => obj.locale === locale )[0];
        if(filter) {
            return filter['label'];
        }
        return "-";
    }

    switch(locale) {
        case ZH_HK: {
            return getLocaleLabel(ZH_HK);
        }
        case EN: {
            return getLocaleLabel(EN);
        }
    }
}

export const getCookie = (cookieName) => {
    let cookie = {};
    document.cookie.split(';').forEach(function(el) {
      let [key,value] = el.split('=');
      cookie[key.trim()] = value;
    })
    return cookie[cookieName];
  }